export default __webpack_public_path__ + "static/Sequel-100-Wide-85-1e8dab495e6a17b405a5a9ab277a3284.ttf";